import ta from "thinkingdata-browser";

// 配置 ThinkingData
const taConfig = {
  appId: process.env.VUE_APP_TD_APP_ID || "ba6b9dbed2b54340b74a03bfd5dd341a",
  serverUrl:
    process.env.VUE_APP_TD_SERVER_URL || "https://dotlog.hurricanegame.cn/",
  autoTrack: {
    pageShow: true,
    pageHide: true,
  },
};
ta.init(taConfig);
